var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.5001V3.49805",
    stroke: "#223944",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.5865C4.5 3.5865 6.3612 3.34375 8.59895 3.78223C10.8367 4.22072 11.8353 5.28256 13.2313 5.91973C14.6274 6.5569 15.2383 6.5412 16.7762 6.46783C18.3462 6.39292 20.5 5.3429 20.5 5.3429L16.924 11.2774L20.5 15.5",
    fill: "#223944"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.5865C4.5 3.5865 6.3612 3.34375 8.59895 3.78223C10.8367 4.22072 11.8353 5.28256 13.2313 5.91973C14.6274 6.5569 15.2383 6.5412 16.7762 6.46783C18.3462 6.39292 20.5 5.3429 20.5 5.3429L16.924 11.2774L20.5 15.5",
    stroke: "#223944",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 14.0864C4.5 14.0864 6.3612 13.8439 8.59895 14.282C10.8367 14.72 11.8353 15.7808 13.2313 16.4174C14.6274 17.0539 15.2383 17.0382 16.7762 16.9649C18.3462 16.8901 20.1969 16.0202 20.5 15.8411",
    fill: "#223944"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.0864C4.5 14.0864 6.3612 13.8439 8.59895 14.282C10.8367 14.72 11.8353 15.7808 13.2313 16.4174C14.6274 17.0539 15.2383 17.0382 16.7762 16.9649C18.3462 16.8901 20.1969 16.0202 20.5 15.8411",
    stroke: "url(#paint0_linear_1782_23267)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79999 3.6001H9.59999L9.59999 7.2001H14.4V10.8001H16.8V12.0001H18V13.2001H19.2V14.6401H20.4V16.4401H19.2V16.8001H18V15.6001H16.8H13.2L10.8 15.6001V14.5001H9.59999L9.59999 14.4001H4.79999V3.6001Z",
    fill: "#223944"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1782_23267",
    x1: 29.5936,
    y1: 19.0629,
    x2: 29.4329,
    y2: 14.9245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223944"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSelected);
export default __webpack_public_path__ + "static/media/flagSelected.63c71e1837ebc435f3d760421d737c5b.svg";
export { ForwardRef as ReactComponent };